export default __webpack_public_path__ + "static/video-05470725dcf571296ec1d44a33f49d62.mp4";